"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//
const Fab_1 = __importDefault(require("./Fab"));
const Card_1 = __importDefault(require("./Card"));
const Chip_1 = __importDefault(require("./Chip"));
const Tabs_1 = __importDefault(require("./Tabs"));
const Menu_1 = __importDefault(require("./Menu"));
const Link_1 = __importDefault(require("./Link"));
const List_1 = __importDefault(require("./List"));
const Table_1 = __importDefault(require("./Table"));
const Alert_1 = __importDefault(require("./Alert"));
const Badge_1 = __importDefault(require("./Badge"));
const Paper_1 = __importDefault(require("./Paper"));
const Input_1 = __importDefault(require("./Input"));
const Radio_1 = __importDefault(require("./Radio"));
const Drawer_1 = __importDefault(require("./Drawer"));
const Dialog_1 = __importDefault(require("./Dialog"));
const Avatar_1 = __importDefault(require("./Avatar"));
const Rating_1 = __importDefault(require("./Rating"));
const Slider_1 = __importDefault(require("./Slider"));
const Button_1 = __importDefault(require("./Button"));
const Switch_1 = __importDefault(require("./Switch"));
const Select_1 = __importDefault(require("./Select"));
const SvgIcon_1 = __importDefault(require("./SvgIcon"));
const Tooltip_1 = __importDefault(require("./Tooltip"));
const Popover_1 = __importDefault(require("./Popover"));
const Stepper_1 = __importDefault(require("./Stepper"));
const DataGrid_1 = __importDefault(require("./DataGrid"));
const Skeleton_1 = __importDefault(require("./Skeleton"));
const Backdrop_1 = __importDefault(require("./Backdrop"));
const Progress_1 = __importDefault(require("./Progress"));
const Timeline_1 = __importDefault(require("./Timeline"));
const TreeView_1 = __importDefault(require("./TreeView"));
const Checkbox_1 = __importDefault(require("./Checkbox"));
const Accordion_1 = __importDefault(require("./Accordion"));
const DatePicker_1 = __importDefault(require("./DatePicker"));
const Typography_1 = __importDefault(require("./Typography"));
const Pagination_1 = __importDefault(require("./Pagination"));
const Breadcrumbs_1 = __importDefault(require("./Breadcrumbs"));
const ButtonGroup_1 = __importDefault(require("./ButtonGroup"));
const Autocomplete_1 = __importDefault(require("./Autocomplete"));
const ToggleButton_1 = __importDefault(require("./ToggleButton"));
const ControlLabel_1 = __importDefault(require("./ControlLabel"));
const LoadingButton_1 = __importDefault(require("./LoadingButton"));
// ----------------------------------------------------------------------
function ComponentsOverrides(theme) {
    return Object.assign((0, Fab_1.default)(theme), (0, Tabs_1.default)(theme), (0, Chip_1.default)(theme), (0, Card_1.default)(theme), (0, Menu_1.default)(theme), (0, Link_1.default)(theme), (0, Input_1.default)(theme), (0, Radio_1.default)(theme), (0, Badge_1.default)(theme), (0, List_1.default)(theme), (0, Table_1.default)(theme), (0, Paper_1.default)(theme), (0, Alert_1.default)(theme), (0, Switch_1.default)(theme), (0, Select_1.default)(theme), (0, Button_1.default)(theme), (0, Rating_1.default)(theme), (0, Dialog_1.default)(theme), (0, Avatar_1.default)(theme), (0, Slider_1.default)(theme), (0, Drawer_1.default)(theme), (0, Stepper_1.default)(theme), (0, Tooltip_1.default)(theme), (0, Popover_1.default)(theme), (0, SvgIcon_1.default)(theme), (0, Checkbox_1.default)(theme), (0, DataGrid_1.default)(theme), (0, Skeleton_1.default)(theme), (0, Timeline_1.default)(theme), (0, TreeView_1.default)(theme), (0, Backdrop_1.default)(theme), (0, Progress_1.default)(theme), (0, Accordion_1.default)(theme), (0, DatePicker_1.default)(theme), (0, Typography_1.default)(theme), (0, Pagination_1.default)(theme), (0, ButtonGroup_1.default)(theme), (0, Breadcrumbs_1.default)(theme), (0, Autocomplete_1.default)(theme), (0, ControlLabel_1.default)(theme), (0, ToggleButton_1.default)(theme), (0, LoadingButton_1.default)(theme));
}
exports.default = ComponentsOverrides;
